import { NavDropdown } from "react-bootstrap";
import "./profileDropdown.scss";
import AvatarIcon from "assets/imgs/icons/avatar.svg";
import ProfileIconPrimary from "assets/imgs/icons/ProfileSmPrimary.svg";
import FaqIcon from "assets/imgs/icons/FaqPrimary.svg";
import LogoutIcon from "assets/imgs/icons/LogoutPrimary.svg";
import { Link } from "react-router-dom";
import { ROUTES } from "routes";
import { AuthContext } from "context/AuthContext";
import { useContext } from "react";
import HeadsetHeader from "assets/imgs/icons/headset_header.svg";
import Profile from "assets/imgs/icons/profile_profileDropdown.svg";
import LogoutHeader from "assets/imgs/icons/logout_header.svg";
import ourPolicies from "assets/imgs/parent/ourPolicies.svg";
import { useQueries } from "@tanstack/react-query";
import downloadImage from "service/shared/image-download";
import BlankAvatar from "assets/imgs/icons/BlankAvatar.svg";
import { useState } from "react";

function ProfileDropdown({ title }) {
  const { isParent, isTutor, isCoordinator, isAdmin, isStudent, logout } =
    useContext(AuthContext);
  const { authState } = useContext(AuthContext);
  const [image, setImage] = useState(null);

  let profile = ROUTES.STUDENT_PROFILE;
  if (isParent()) {
    profile = ROUTES.PARENT_PROFILE;
  } else if (isTutor()) {
    profile = ROUTES.TUTOR_PROFILE;
  } else if (isCoordinator()) {
    profile = ROUTES.CSM_VIEW_PROFILE;
  } else if (isAdmin()) {
    profile = ROUTES.ADMIN_PROFILE;
  } else if (isStudent()) {
    profile = ROUTES.STUDENT_PERSONAL_PROFILE;
  }

  const queries = useQueries({
    queries: [
      {
        queryKey: [
          `parent-${authState?.userInfo?.cifNumber}-image`,
          authState?.userInfo?.cifNumber,
        ],

        queryFn: () => downloadImage(authState?.userInfo?.cifNumber),
        enabled: !!authState?.userInfo?.cifNumber,

        onSuccess: (file) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () =>
            setImage(reader.result === "data:" ? null : reader.result);
        },
      },
    ],
  });
  return (
    <div id="basic-nav-dropdown" className="profileDropdown__profile_wrapper">
      <NavDropdown
        title={
          <>
            <img
              className="cursor-pointer profileDropdown-avt-img"
              src={image ? image : BlankAvatar}
              alt=""
            />
            <span className="ms-2 header__nav-link-group profileDropdown__title cursor-pointer">
              {title}
            </span>
          </>
        }
        id="basic-nav-dropdown"
        className="cursor-pointer"
      >
        <Link
          to={profile}
          className="cursor-pointer d-flex align-items-center gap-3 my-1 profileDropdown__profile_dropdown_item"
        >
          <img src={Profile} alt="" />
          <span>Profile</span>
        </Link>
        {isParent() && (
          <>
            <Link
              to={ROUTES.FAQ}
              className="cursor-pointer d-flex align-items-center gap-3 my-1 profileDropdown__profile_dropdown_item"
            >
              <img src={HeadsetHeader} alt="" />
              <span>Help</span>
            </Link>
            <Link
              to={ROUTES.POLICIES}
              className="cursor-pointer d-flex align-items-center gap-3 my-1 profileDropdown__profile_dropdown_item"
            >
              <img src={ourPolicies} alt="" />
              <span>Our Policies</span>
            </Link>
          </>
        )}
        <div
          onClick={logout}
          className="cursor-pointer d-flex align-items-center gap-3 my-1 profileDropdown__profile_dropdown_item"
        >
          <img src={LogoutHeader} alt="" />
          <span>Logout</span>
        </div>
      </NavDropdown>
    </div>
  );
}

export default ProfileDropdown;
